import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';
import type { InboxEntry } from '@/lib/mentionsInbox';
export const InboxSampleContext = createContext<{
  entries: InboxEntry[];
  setEntries: Dispatch<SetStateAction<InboxEntry[]>>;
} | null>(null);
export function useInboxSample() {
  const value = useContext(InboxSampleContext);
  if (!value) throw new Error('Inbox sample provider missing');
  return value;
}
